export const styles = {
    alertPopUp: {
        backgroundColor: '#3876AA',
        color: 'white',
        textTransform: 'none',
        borderRadius: 2,
        p: 2,
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
    },
};
export default styles;
